export default {
  list: {
    headers: {
      isNewAccredible: "New accredible?",
    },
  },
  form: {
    labels: {
      isNewAccredible: "Is new accredible?",
    },
  },
  generate: {
    title: "Generate certificate",
    labels: {
      type: "Type",
      user: "User",
      exam: "Exam",
      program: "Program",
    },
    placeholders: {
      user: "Select user",
      exam: "Select exam",
      program: "Select program",
    },
    types: {
      exam: "Exam",
      program: "Program",
    },
    buttons: {
      submit: "Generate certificate",
    },
    validation: {
      type: "Select certificate type",
      user: "Select user",
      model: "Select item",
    },
    errors: {
      fetchUsers: "Failed to load users list",
      fetchModels: "Failed to load list",
      submit: "Failed to generate certificate",
    },
    result: {
      certificateLink: "Certificate link",
      certificatePreview: "Certificate preview",
      credentialId: "Credential ID",
    },
  },
};
